<template>
  <!--添加工作经历-->
  <div>
    <headers></headers>
    <div class="title">
      <div class="auto">首页  >  学分银行  >  学分转换  >  申请学分转换</div>
    </div>
    <div class="padding250">
      <div class="auto">
        <div class="content">
          <p class="titleName">申请转换证明记录</p>
          <ul class="jilulist">
            <li v-for="item in changeList">
              <ul>
                <li>证书编号：{{item.certificateNum}} <p class="pull-right">状态：
                  <span v-if="item.auditState == 1">待审核</span>
                  <span v-if="item.auditState == 2">审核成功</span>
                  <span v-if="item.auditState == 3">审核失败</span>
                </p></li>
                <li>证书名称：《{{item.certificateName}}》</li>
                <li class="date">{{item.createTime.substring(0,17)}}</li>
              </ul>
            </li>
          </ul>
          <span v-if="changeList.length < 1">
              <nodata tip="暂时还没有转换证明记录~"></nodata>
          </span>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>

</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .padding250 .auto{
    background-color: #fff;
    margin-top: 30px;
    text-align: left;
    .content{
      padding: 40px;
      .titleName{
        font-size: 20px;
        color: #000;
        margin-bottom: 40px;
      }
      .jilulist{
        >li{
          border-bottom: 1px dashed #DBDBDB;
          font-size: 14px;
          color: #000;
          line-height: 30px;
          padding-bottom: 20px;
          margin-bottom: 20px;
          .date{
            color: #666;
          }
          .pull-right{
            span{
              color: #999;
            }
          }
        }
      }
    }
  }
  .title{
    font-size: 14px;
    color: #fff;
    height: 60px;
    line-height: 60px;
    background-color: #2F261E;
    text-align: left;
  }









</style>
<script type="text/ecmascript-6">
  import nodata from '../template/null'
  import headers from '../template/header'
  import footers from '../template/footer'
  import {getchangeList} from '../../http'

  export default {
    name: 'changeRecord',
    props: {},
    data() {
      return {
        changeList: []
      };
    },
    methods: {
      //报考认定考试
      getInfo(){
        let that = this
        getchangeList().then(res => {
          console.info(res)
          if(res.code === 200){
            that.changeList = res.data
          }
        })
      },
    },
    created() {
      this.getInfo()
    },
    components: {
      headers,
      footers,
      nodata
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/continuEducation/applayjilu.vue